export const scrapeLumaEvent = async (url: string) => {
    try {
        // Validate it's a luma URL
        if (!url.includes("lu.ma")) {
            return null;
        }

        // Extract the event ID from the URL (e.g., "ruq5nae2" from "lu.ma/ruq5nae2")
        const eventId = url.split("/").pop();
        if (!eventId) {
            throw new Error("Could not extract event ID from URL");
        }

        // Fetch from Luma's API directly
        const apiUrl = `https://api.lu.ma/url?url=${eventId}`;
        const response = await fetch(apiUrl);
        const lumaResponse = await response.json();
        const event = lumaResponse.data.event;

        console.log("API Response:", lumaResponse);

        return {
            name: event?.name,
            description: event?.description,
            startTime: event?.start_at ? new Date(event?.start_at) : null,
            endTime: event?.end_at ? new Date(event?.end_at) : null,
            location: event?.geo_address_info?.full_address,
            city: event?.geo_address_info?.city,
            country: event?.geo_address_info?.country,
            timezone: event?.timezone,
            googlePlace: {
                id: event?.geo_address_info?.place_id,
                name: event?.geo_address_info?.address,
                geometry: {
                    latitude: event?.geo_latitude,
                    longitude: event?.geo_longitude,
                },
            },
            originalUrl: url,
        };
    } catch (error) {
        console.error("Error fetching Luma event:", error);
        throw new Error("Failed to fetch event details");
    }
};

export type ScrapedLumaEvent = {
    name: string | undefined;
    description: string | undefined;
    startTime: Date | null;
    endTime: Date | null;
    location: string | undefined;
    originalUrl: string;
};
